module.exports = __webpack_public_path__ + "img/up.158273fb.svg";